<template>
    <div class="brandable-modal-page">
        <div class="images-container">
            <div class="floating-editor">
                <div @click="() => {collapsed = !collapsed}" class="arrow-container">
                    <div class="arrow" :class="collapsed ? 'right' : 'left'"></div>
                </div>
                <div v-if="!collapsed"class="floating-edit-options">
                    <div class="floating-container">
                        <div @click="() => {collapsedNotes = !collapsedNotes}" class="fixed-container clickable"  >
                            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/editicon_blue.svg?v=1711657195"/> <p>Add Design Note</p> <div class="arrow" :class="collapsedNotes ? 'down' : 'up'"></div>
                        </div>
                        <div v-show="!collapsedNotes">
                            <textarea style="width: 100%;resize: none;" v-model="designNotes" placeholder="Please add instructions" type="text"></textarea>
                        </div>
                    </div>
                    <div @click="alignLogo(currentDesignIndex)" class="floating-container clickable">
                        <div class="fixed-container">
                            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/align.svg?v=1711657195"/>
                            <p>Align Logo</p>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
            <p @click="goBack()" class="exit">< BACK</p>
            <div class="title-container mobile">
                <p class="title">{{selectedAddon.title}} <br/> <span class="turnaround">This item typically has a 2-4 week turnaround</span></p>
                <div class="information-container">
                    <div @click="() => {showDesc = !showDesc}" class="information-toggle" :class="showDesc ? 'toggle' : ''">
                        <span>Product Information </span>
                        <div class="arrow" :class="!showDesc ? 'down' : 'up'"></div>
                    </div>
                    <div v-if="showDesc" class="desc-outer-container">
                        <p class="desc" v-html="productDesc"></p>
                    </div>
                    <div v-if="showDesc" class="curtain"></div>
                </div>
            </div>
            <div class="image-outer-container">
                <div  class="main-image-container" id="draggableContainer">
                    <img :src="currentMainImage.src" class="main-image">
                    <div @mouseover="designs[currentDesignIndex].active = true" @mouseleave="deactivateDesign()" v-if="currentDesign && currentDesign.file" id="iContainer" class="image-editor-container" :class="designs[currentDesignIndex].shape ? designs[currentDesignIndex].shape : ''">
                        <DDR @click="activateDesign" id="ddr" v-model="designs[currentDesignIndex].transform" :active="designs[currentDesignIndex].active" :parent="false">
                            <img  class="edit-image" :src="currentDesign.img"/>
                        </DDR>
                    </div>
                </div>
                <div v-if="currentImageList.length > 1" class="image-selectors">
                    <button @click="changeImageIndex(false)" class="image-back"><</button>
                    <button @click="changeImageIndex(true)" class="image-fw">></button>
                </div>
            </div>
        </div>
        <div class="customization-container">
            <div class="title-container desktop">
                <p class="title">{{selectedAddon.title}} <br/> <span class="turnaround">This item typically has a 2-4 week turnaround</span></p>
                <div class="information-container">
                    <div @click="() => {showDesc = !showDesc}" class="information-toggle" :class="showDesc ? 'toggle' : ''">
                        <span>Product Information </span>
                        <div class="arrow" :class="!showDesc ? 'down' : 'up'"></div>
                    </div>
                    <div v-if="showDesc" class="desc-outer-container">
                        <p class="desc" v-html="productDesc"></p>
                    </div>
                    <div v-if="showDesc" class="curtain"></div>
                </div>
            </div>
            <div class="design-container"  v-if="designs.length > 0">
                <p class="title">1. Upload your designs</p>
                <div class="design-input-container" v-for="(design,i) in designs">
                    <input :id="'file'+ design.imgIndex" @change="designUpload($event,i)" class="file-uploader" type="file" />
                    <label class="outer-label" :for="'file'+ design.imgIndex">
                        <div v-if="!design.file" class="inner-label">
                            <span class="main-text"> 
                                Upload {{design.name}} Design <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/upload_purple.svg?v=1710535518"/>
                            </span>
                        </div>
                        <div v-else class="inner-label">
                            <span><strong>{{design.name}}:</strong></span>
                            <span class="main-text">{{ design.fileName }}</span>
                        </div>
                    </label>
                    <p v-if="design.file" class="clear-image" @click="clearImage(i)">X</p>
                </div>
                <p class="legend">
                    <img class="i-icon" src="https://cdn.shopify.com/s/files/1/1363/8433/files/info_icon_462d2e20-cb40-4eb2-9831-90a9babb7cce.svg?v=1700501409"/>
                    <span>Max file size is 10mb. Accepted file types are .png, .jpg, .jpeg and .svg</span>
                </p>
            </div>
            <div v-if="hasVariants && colorOptions" class="color-container">
                <p class="title">2. Choose Color</p>
                <div class="variant-container">
                    <div class="colors-button-container">
                        <div :style="'background:' + colors[variant.toLowerCase()]" @click="selectVariant(colorOptions.position - 1,variant)" :class="optionsSelected[colorOptions.position - 1] == variant ? 'selected' : ''" v-for="(variant,i) in colorOptions.values" :key="variant" class="round-color"></div>
                    </div>
                </div>
            </div>
            <div v-if="hasVariants" v-for="(option,i) in nonColorOptions" class="option-container">
                <p class="title">{{ colorOptions ? 3+i : 2+i }}. Choose Available {{ option.name }}</p>
                <div class="variants-button-container">
                    <button class="happybox-button white" :class="optionsSelected[option.position - 1] == variant ? 'selected' : ''" @click="selectVariant(option.position - 1,variant)" v-for="(variant,i) in option.values" :key="variant">
                        {{variant}}
                    </button>
                </div>
                <p class="legend">
                    <img class="i-icon" src="https://cdn.shopify.com/s/files/1/1363/8433/files/info_icon_462d2e20-cb40-4eb2-9831-90a9babb7cce.svg?v=1700501409"/>
                    <span>
                        Your design is applied directly onto the products' surface by pushing ink through
                        a fine mesh screen. This is one of our most popular decoration methods.
                    </span>
                </p>
            </div>
            <div v-if="hasSizes && qtySizes" class="sizes-container">
                <p class="title">4. Set Sizes and Quantity (Minimum:{{ qtyMin }})</p>
                <p class="no-size">
                    <input v-model="noSizes" type="checkbox"/>
                    <span>I don't know the sizes. (Don't worry you can contact us later via email)</span>
                </p>
                <div v-if="!noSizes" class="sizes-selection-container">
                    <div v-for="(size,i) in metafields.brandable_variant_size" class="size-selection">
                        <p>{{ size }}</p>
                        <input min="0" v-model="qtySizes[i].qty" type="number">
                    </div>
                </div>
                <div v-else class="sizes-selection-container">
                    <div class="size-selection">
                        <p>Qty</p>
                        <input min="0" v-model="selectedQty" type="number">
                    </div>
                </div>
                <p class="total-qty">Total of <span :class="currentSelectedQty < qtyMin ? 'red' : ''">{{ currentSelectedQty }}</span> {{selectedAddon.title}} (MIN:{{ qtyMin }})</p>
            </div>
            <div class="sizes-container" v-else>
                <p class="title">{{ hasVariants ? (colorOptions ?'4' : '3') : '2' }}. Set Quantity (Minimum:{{ qtyMin }})</p>
                <div class="sizes-selection-container">
                    <div class="size-selection">
                        <p>Qty</p>
                        <input min="0" v-model="selectedQty" type="number">
                    </div>
                </div>
                <p class="total-qty">Total of <span :class="currentSelectedQty < qtyMin ? 'red' : ''">{{ currentSelectedQty }}</span> {{selectedAddon.title}} (MIN:{{ qtyMin }})</p>
            </div>
            <div v-if="extraInputs.length > 0" class="inputs-container">
                <p class="title">Additional Customization</p>
                <div class="input-selection-container">
                    <div v-for="input in extraInputs" class="input-selection">
                        <p>{{input.name}}</p>
                        <input :class="input.inputType" v-model="input.value" :type="input.inputType" v-bind="input.properties">
                    </div>
                </div>
            </div>
            <div class="mobile-sticky">
                <p class="product-total"><span>Total:</span><span>$ {{ currentPrice }}</span></p>
                <button @click="updateMainAddonProductQuantity" :disabled="!canAdd" class="happybox-button green border" :class="isLoading ? 'isLoading' : ''">{{isLoading ? 'loading...' : 'Add to Cart & Continue'}}</button>
            </div>
        </div>
        <div class="color-modal" v-if="showColorModal">
            <div class="color-modal-container">
                <p class="title">Backup Color</p>
                <p class="subtitle">You have selected {{ currentSelectedColor }} color. Please select 2 backup colors you'd be happy with.</p>
                <div class="main-container">
                    <div class="current-pick">
                        <div class="title">
                            <span>Current Pick</span>
                            <div :style="'background:' + colors[currentSelectedColor.toLowerCase()]" class="round-color"></div>
                        </div>
                        <img :src="this.currentImageList[0].src"/>
                    </div>
                    <div class="color-pick">
                        <div v-if="hasVariants && colorOptions" class="variant-container">
                            <p class="title">Select back up color options</p>
                            <div class="colors-button-container">
                                <div :style="'background:' + colors[variant.toLowerCase()]" @click="selectReplacementColor(variant)" :class="secondaryColors.includes(variant) ? 'selected' : ''" v-for="(variant,i) in sColors" :key="variant" class="round-color"></div>
                            </div>
                        </div>
                        <div>
                            <p class="final-design">Don't worry! We'll confirm your final design before it goes into production</p>
                            <div class="color-results">
                                <div>
                                    <p class="selected-colors">
                                        <span>Selected</span>
                                    </p>
                                    <div :style="'background:' + colors[variant.toLowerCase()]"  v-for="(variant,i) in secondaryColors" class="round-color"></div>
                                </div>
                                <p class="selected-colors">
                                    <span class="qty">{{ secondaryColors.length }}/{{ requiredSecondaryColors }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <p v-if="showColorError" class="red-alert">Please select 2 backups colours in order to proceed.</p>
                <button @click="finishColors()" class="happybox-button" :class="secondaryColors.length != requiredSecondaryColors ? 'grey disabled' : 'green border'">Add to Cart & Continue</button>
            </div>
        </div>
        <div class="global-spinner-container" v-if="isLoading">
            <div class="global-spinner"></div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import colors from '../assets/colors.js'
import axios from 'axios';
import DDR from 'yoyoo-ddr-vue2'
import 'yoyoo-ddr-vue2/dist/yoyoo-ddr.css'
import * as html2canvas from 'html2canvas';
export default {
    props: {
        selectedAddon: Object
    },
    data() {
        return {
            selectedImage: null,
            metafields: null,
            designs: [],
            showDesc: false,
            optionsSelected: [],
            selectedQty: 1,
            selectedImageIndex: 0,
            qtySizes: null,
            noSizes: true,
            ignoreMinimum: false,
            secondaryColors: [],
            designNotes: "",
            showColorModal:false,
            showColorError: false,
            collapsed: false,
            isLoading: false,
            collapsedNotes: true,
            extraInputs: [],
        }
    },
    components:{
        DDR
    },
    computed:{
        ...mapGetters([
            'collectionProducts',
            'cardProducts',
            'mainCollection',
            'categoriesList'
        ]),
        currentImageList(){
            return this.selectedAddon.images.filter(x => x.variant_ids.length == 0 || x.variant_ids.includes(this.selectedVariant.id));
        },
        currentMainImage(){
            return this.currentImageList[this.selectedImageIndex]
        },
        colors(){
            return colors;
        },
        currentSelectedColor(){
           return this.optionsSelected[this.colorOptions.position - 1];
        },
        currentDesignIndex(){
            if(this.designs.length > 0){
                return this.designs.findIndex(x => x.imgIndex == (this.selectedImageIndex + 1));
            }
            
            return null;
        },
        currentDesign(){
            if(this.designs.length > 0){
                return this.designs.find(x => x.imgIndex == (this.selectedImageIndex + 1));
            }

            return null
        },
        productDesc(){
            var desc = this.selectedAddon.body_html.split("&lt;---ingredients---&gt;")[0];
            return desc;
        },
        hasVariants(){
            return this.selectedAddon.variants.length > 1 && this.selectedAddon.variants.every(x => !x.sku || !x.sku.toLowerCase().includes("ondemand"));
        },
        colorOptions(){
            return this.selectedAddon.options.find(x => x.name.includes("Color"));
        },
        nonColorOptions(){
            return this.selectedAddon.options.filter(x => !x.name.includes("Color") && !x.name.includes("Printing Qty"));
        },
        hasSizes(){
            return this.metafields && this.metafields.brandable_variant_size && this.metafields.brandable_variant_size.length > 0;
        },
        selectedVariant(){
            let productsVariants = this.selectedAddon.variants;
            for (let [i, option] of this.optionsSelected.entries()) {
                productsVariants = productsVariants.filter(x => x["option"+(i+1)] == option);
            }
            if(productsVariants.length == 1){
                return productsVariants[0];
            }

            return this.selectedAddon.variants[0];
        },
        currentVariantProduct(){
            var variantProduct = JSON.parse(JSON.stringify(this.selectedAddon));
            variantProduct.variants = [this.selectedVariant]

            return variantProduct;
        },
        currentPrice(){
            return (Math.round(parseFloat(this.selectedVariant.price) * 100 * this.currentSelectedQty)) /100;
        },
        hasQtyMin(){
            let tags = [];
            if(Array.isArray(this.selectedAddon.tags)){
                tags = this.selectedAddon.tags;
            }
            else {
                tags = this.selectedAddon.tags.split(", ");
            }
            return tags.find(x => x.includes("QTYMIN"));
        },
        qtyMin(){
            if(this.hasQtyMin){
                let tags = [];
                if(Array.isArray(this.selectedAddon.tags)){
                    tags = this.selectedAddon.tags;
                }
                else {
                    tags = this.selectedAddon.tags.split(", ");
                }
                let minTag = tags.find(x => x.includes("QTYMIN"));
                if(minTag){
                    minTag = minTag.split("_");
                    minTag = minTag[minTag.length - 1];

                    return  parseInt(minTag);
                }
            }

            return 0;
        },
        currentSelectedQty(){
            if(this.hasSizes && this.noSizes){
                return this.selectedQty;
            }
            if(this.qtySizes && this.qtySizes.length > 0){
                return this.qtySizes.reduce((prev, next) => prev + parseInt(next.qty ? next.qty : 0), 0);
            }

            return this.selectedQty;
        },
        canAdd(){
            return this.currentSelectedQty >= this.qtyMin;
        },
        printVariant(){
            return this.selectedAddon.options.find(x=> x.name.toLowerCase().includes("printing qty"));
        },
        requiredSecondaryColors(){
            return Math.min(this.colorOptions.values.length - 1,2);
        },
        sColors(){
            return this.colorOptions.values.filter(x => !this.optionsSelected.includes(x));
        },
        productProperties(){
            let properties = [];
            for(let design of this.designs){
                if(design.file){
                    properties.push({name: `${this.selectedAddon.title}_${design.name}_file` ,value:design.file});
                    properties.push({name: `${this.selectedAddon.title}_${design.name}_custom` ,value:design.custom});
                    properties.push({name: `_showImage` ,value:`${this.selectedAddon.title}_${design.name}_custom`});
                    properties.push({name: `_customUrl` ,value:design.customUrl});
                }
            }
            if(this.hasSizes && this.noSizes){
                properties.push({name:"_no size",value: true});
            }
            else if(this.hasSizes && !this.noSizes && this.qtySizes){
                let filteredSizes = this.qtySizes.filter(x => x.qty > 0);
                properties.push({name:"_sizes",value: filteredSizes});
            }
            if(this.secondaryColors.length > 0){
                properties.push({name:`${this.selectedAddon.title}_colors`,value: this.secondaryColors.join(", ")});
            }
            if(this.designNotes.trim() != ""){
                properties.push({name:`${this.selectedAddon.title}_notes`,value: this.designNotes});
            }
            if(this.qtyMin)
                properties.push({name:`qtyMin`,value: this.qtyMin});
            if(this.extraInputs.length > 0){
                properties = properties.concat(this.extraInputs.map((x) => {
                    return {
                        name:`${this.selectedAddon.title}_${x.name}`,
                        value: x.value
                    }
                }))
            }

            return properties
        },
        hasCollection(){
            return this.mainCollection && this.mainCollection.handle;
        },
    },
    methods:{
        goBack(){
            this.$emit("close");
        },
        selectReplacementColor(variant){
            let index = this.secondaryColors.indexOf(variant);
            if(index == -1){
                if(this.secondaryColors.length < this.requiredSecondaryColors)
                    this.secondaryColors.push(variant);
            }
            else{
                this.secondaryColors.splice(index, 1);
            }
        },
        finishColors(){
            if(this.secondaryColors.length == this.requiredSecondaryColors){
                this.showColorModal = false;
                this.showColorError = false;
                this.updateMainAddonProductQuantity();
            }
            else{
                this.showColorError = true;
            }
        },
        selectVariant(position,value){
            this.$set(this.optionsSelected, position, value);
        },
        changeImageIndex(increment){
            if(increment){
                if(this.currentImageList.length == this.selectedImageIndex + 1){
                    this.selectedImageIndex = 0;
                    return
                }
                this.selectedImageIndex++;
            }
            else{
                if(this.selectedImageIndex == 0){
                    this.selectedImageIndex = (this.currentImageList.length - 1);
                    return
                }
                this.selectedImageIndex--;
            }
        },
        clearImage(i){
            this.designs[i].file = null;
            this.designs[i].img = null;
            this.designs[i].fileName = null;
            if(this.printVariant){
                let files = this.designs.filter(x => x.file);
                this.$set(this.optionsSelected, this.printVariant.position - 1,  Math.max(1,files.length));
            }
        },
        alignLogo(i){
            let element = document.getElementById("iContainer");
            if(element){
                let eData = element.getBoundingClientRect();
                let ddr = document.getElementsByClassName("yoyoo-ddr");
                let x = (eData.width / 2) - (this.designs[i].transform.width/2);
                let y = (eData.height / 2) - (this.designs[i].transform.height/2);
                ddr[0].style.left = `${x}px`;
                ddr[0].style.top = `${y}px`;
                this.designs[i].transform.x = x;
                this.designs[i].transform.y = y;
            }
        },
        async designUpload(event,i){
            let file = event.target.files[0] ? event.target.files[0] : null;
            if (file) {
                const reader = new FileReader();
                let that = this;
                reader.readAsDataURL(file);
                const result = await new Promise((resolve, reject) => {
                    reader.onload = function(e) {
                        that.designs[i].file = file;
                        that.designs[i].img = e.target.result;
                        that.designs[i].fileName = file.name;
                        that.selectedImageIndex = (that.designs[i].imgIndex - 1);
                        if(file.type.includes("svg")){
                            let svgString = atob(e.target.result.replace(/data:image\/svg\+xml;base64,/, ''));
                            var re = /#[0-9a-f]{3,6}/gi;
                            let colors = svgString.match(re);
                            that.designs[i].colors = colors;
                            that.designs[i].isVector = true;
                        }
                        resolve(reader.result)
                    }
                })
            }
            event.target.value = '';
            
            if(this.printVariant){
                let files = this.designs.filter(x => x.file);
                this.$set(this.optionsSelected, this.printVariant.position - 1, Math.max(1,files.length));
            }
        },
        activateDesign(){
            this.designs[this.currentDesignIndex].active = true;
        },
        async deactivateDesign(){
            this.designs[this.currentDesignIndex].active = false;
            await this.$nextTick();
            const canvas = await html2canvas(document.querySelector("#draggableContainer"),{allowTaint:false,useCORS:true});
            const blob = this.dataURLtoBlob(canvas.toDataURL('image/png'));
            this.designs[this.currentDesignIndex].custom = new File([blob], "custom.png");
            this.designs[this.currentDesignIndex].customUrl = canvas.toDataURL('image/png');
        },
        updateMainAddonProductQuantity(){
            this.customAlert = '';
            if(this.designs.filter(x => x.file).length == 0){
                this.openDesignAlert();
                return;
            }
            if(!this.extraInputs.every(x => x.value != null && x.value != "")){
                this.openExtraAlert();
                return
            }
            if(this.hasVariants && this.colorOptions && this.secondaryColors.length < this.requiredSecondaryColors && this.requiredSecondaryColors == 2){
                this.showColorModal = true;
                return;
            }
            this.shipIndividually()
        },
        shipIndividually(){
            this.isLoading = true;
            let properties = {};
            for(let property of this.productProperties){
                properties[property.name] = property.value;
            }
            let item = {
                id: this.currentVariantProduct.variants[0].id,
                quantity: this.currentSelectedQty,
                properties: properties,
            }
            let request = {items:[]};
            if(item.properties["_sizes"]){
                let sizes = item.properties["_sizes"];
                request.items = sizes.map((x) =>{
                    let sizeItem = {
                        id: this.currentVariantProduct.variants[0].id,
                        quantity: x.qty,
                        properties: properties,
                    }

                    sizeItem.properties[`${this.currentVariantProduct.title}_size`] = x.name;

                    return sizeItem;
                })
            }
            else
                request.items = [item]
            this.ajaxAddBulk(request);
        },
        async ajaxAddBulk(items){
            const formData = this.objectToFormData(items);
            await axios.post("/cart/add.js",formData)
            localStorage.setItem("cartDate",Date.now());
            localStorage.setItem('finishedBox',true);
            this.isLoading = false;
            this.goBack();
            if (typeof window.openCartDrawer === 'function') {
                window.openCartDrawer()
            }
        },
        objectToFormData(obj, formData = new FormData(), parentKey = '') {
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const value = obj[key];
                    const formKey = parentKey ? `${parentKey}[${key}]` : key;

                    if (value instanceof File || value instanceof Blob) {
                        formData.append(formKey, value);
                    } else if (value instanceof Date) {
                        formData.append(formKey, value.toISOString());
                    } else if (Array.isArray(value)) {
                        value.forEach((item, index) => {
                            const arrayKey = `${formKey}[${index}]`;
                            if (typeof item === 'object' && !Array.isArray(item)) {
                                this.objectToFormData(item, formData, arrayKey);
                            } else {
                                formData.append(arrayKey, item);
                            }
                        });
                    } else if (typeof value === 'object' && !Array.isArray(value)) {
                        this.objectToFormData(value, formData, formKey);
                    } else {
                        formData.append(formKey, value);
                    }
                }
            }
            return formData;
        },
        dataURLtoBlob(dataurl) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {type:mime});
        },
        changeMinBoxQty(){
            var canUpdate = this.cartProducts.filter((x) =>{
                if((this.qtyMin * (x.quantity)) >= x.variants[0].inventory_quantity)
                    return true

                return false
            })

            if(canUpdate.length > 0){
                for(let addon of canUpdate){
                    this.removeProduct(addon);
                }
            }

            this.boxQty = Math.max(this.qtyMin,this.currentSelectedQty);
        },
        removeProduct(product){
            this.$store.commit('removeSelectedAddonProductNew', product);
        },
        incrementBoxQty(increment){
            if(increment){
                this.changeBoxQty(this.boxQty + 1);
            }
            else {
                if(this.boxQty > 1){
                    this.changeBoxQty(this.boxQty - 1);
                }
            }
        },
        incrementProductQty(increment){
            if(increment){
                this.changeBoxQty(this.boxQty + 1);
            }
            else {
                if(this.boxQty > 1){
                    this.changeBoxQty(this.boxQty - 1);
                }
            }
        },
        changeBoxQty(qty){
            var canUpdate = this.cartProducts.filter((x) =>{
                if((qty * (x.quantity)) >= x.variants[0].inventory_quantity)
                    return true

                return false
            })

            if(canUpdate.length > 0){
                for(let addon of canUpdate){
                    this.removeProduct(addon);
                }
            }

            this.boxQty = qty;
        },
        openDesignAlert(){
            const alertText = `<p class="title">Please upload your logo <br/> in order to proceed</p>`;
            Swal.fire({
                iconHtml: `<img src="https://cdn.shopify.com/s/files/1/1363/8433/files/error_icon_2a88e148-df0e-480c-85b8-89b7d9d6e5ba.svg?v=1741881886" class="alert-icon"/>`,
                html: alertText,
                confirmButtonText: 'Back to product',
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup-3",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                },
                buttonsStyling: false,
                })
        },
        openExtraAlert(){
            const alertText = `<p class="title">Please fill all fields in order to proceed</p>`;
            Swal.fire({
                iconHtml: `<img src="https://cdn.shopify.com/s/files/1/1363/8433/files/error_icon_2a88e148-df0e-480c-85b8-89b7d9d6e5ba.svg?v=1741881886" class="alert-icon"/>`,
                text: alertText,
                confirmButtonText: 'Back to product',
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup-3",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                },
                buttonsStyling: false,
                })
        },
    },
    mounted(){
        if(this.selectedAddon){
            let tags = [];
            if(Array.isArray(this.selectedAddon.tags)){
                tags = this.selectedAddon.tags;
            }
            else {
                tags = this.selectedAddon.tags.split(", ");
            }
            var isBrandable = tags.filter(y => y.includes("Brandable Swag"));
            if(isBrandable){
                axios.get(`/products/${this.selectedAddon.handle}?view=metafields`).then((res) => {
                    if(res && res.data && res.data.metafields){
                        this.metafields = res.data.metafields;
                        if(this.metafields.designs){
                            this.designs = this.metafields.designs.map((x) => {
                                let splitInfo = x.split(":");
                                return {
                                    name: splitInfo[0]
                                    ,imgIndex:splitInfo[1]
                                    ,shape:splitInfo[2] ? splitInfo[2].toLowerCase() : 'square'
                                    ,file:null
                                    ,img:null
                                    ,fileName: null
                                    ,transform: { x: 0, y: 0, width: 100, height: 100, rotation: 0 }
                                    ,isVector: false
                                    ,colors: []
                                    ,active:false
                                    ,custom: null
                                    ,customUrl: null
                                }
                            })
                        }
                        if(this.metafields.brandable_variant_size){
                            this.qtySizes = this.metafields.brandable_variant_size.map((x,i) => {
                                return {name:x, qty:0}
                            })
                        }
                        if(this.metafields.extra_inputs){
                            this.extraInputs = this.metafields.extra_inputs.map((x) => {
                                if(x.inputProperties && x.inputProperties.length > 0){
                                    x.properties = {};
                                    for(let property of x.inputProperties){
                                        x.properties[property.name] = property.value;
                                    }
                                }
                                return x;
                            });
                        }
                        let minTag = tags.find(x => x.includes("QTYMIN"));
                        if(minTag){
                            minTag = minTag.split("_");
                            minTag = minTag[minTag.length - 1];

                            this.selectedQty = parseInt(minTag);
                        }
                    }
                })
                for (let [i, option] of this.selectedAddon.options.entries()) {
                    this.optionsSelected[i] = option.values[0]; 
                }
            }
            else {
                this.metafields = null;
            }
        }
        
    },
}
</script>

<style lang="scss" scoped>
.brandable-modal-page p,.brandable-modal-page span{
    margin:0;
    color: #0F0C38;
}
.happybox-button.grey{
    background-color: #E0E0E0;
    border: 1px solid gray;
}

.happybox-button.grey.disabled{
    opacity: 0.6;
}

.happybox-button.grey:hover{
    background-color: lightgray;
}

.brandable-modal-page{
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    z-index: 1000;
    position: fixed;
    height: calc(100%);
    width: 100%;
    top: 0px;
    left: 0;
}

.images-container{
    width: 50%;
    height: 100%;
    padding: 2% 5%;
    position: relative;
}

.image-outer-container{
    position: relative;
    width: 100%;
}

.images-container .main-image-container{
    display: flex;
    position: relative;
    width: 100%;
    justify-content: center;
    height: 100%;
}

.image-selectors{
    position: absolute;
    bottom: 5%;
    display: flex;
    align-items: center;
    gap: 15px;
    width: 100%;
    justify-content: center;
    height: auto;
    line-height: 1;
}

.image-selectors button{
    width: 2.5vw;
    background-color: white;
    line-height: 1;
    aspect-ratio: 1;
    border-radius: 4px;
    color: #0f0c38;
    font-size: 1.5vw;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 0 4px 0px #0000004d;
}

.image-selectors button:hover{
    background-color: #faf7fe;
}

.main-image{
    background-color: #f6f6f6;
    max-width: 100%;
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
}

.exit{
    font-size: 1.3vw;
    cursor: pointer;
    font-weight: bold;
    margin-bottom: 5%;
    color: #a01adb;
}

.customization-container{
    width: 50%;
    background-color: #f8f8f8;
    height: 100%;
    border-left: 1px solid #E3E3E3;
    padding: 2% 5%;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
}

.image-editor-container{
    position: absolute;
    z-index: 1;
    left: 20%;
    top: 20%;
    width: 60%;
    height: 60%;
}

.image-editor-container.circle{
    border-radius: 50%;
}

.image-editor-container:hover{
    border: 1px solid black;
}

.image-editor-container.top-left-handle{
    width: 20%;
    top: 0;
    right: 10%;
    left: unset;
    height: 20%;
}


.edit-image{
    max-width: 100%;
    max-height: 100%;
}

.title-container{
    width: 100%;
    border-bottom: 1px solid #E3E3E3;
    align-items: center;
    padding-bottom: 2%;
    margin-bottom: 2%;
    gap: 5px;
    justify-content: space-between;
}

.title-container.mobile{
    display: none;
}

.title-container.desktop{
    display: flex;
    align-items: flex-start;
}

.title-container.desktop .information-toggle{
    margin-top: 0.3rem;
}

.title-container .title{
    font-size: 2.5vw;
    font-family: Karla, sans-serif;
    font-weight: bold;
    line-height: 1.2;
}

.information-container{
    display: flex;
    align-items: center;
    position: relative;
    width: 35%;
}

.title-container .information-toggle{
    border: 1px solid #bdc1ce;
    padding: 4% 10%;
    background-color: #e6ebfb;
    font-size: 1vw;
    font-weight: bold;
    border-radius: 8px;
    flex-shrink: 0;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
}

.title-container .information-toggle.toggle{
    border: unset;
    border-radius: unset;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    margin-top: 10%;
    z-index: 1;
}

.desc-outer-container{
    position: absolute;
    border: 5px solid #e6ebfb;
    border-radius: 8px;
    padding: 10%;
    background-color: #fff;
    z-index: 1;
    top: 100%;
    right: -10%;
    width: 310%;
    height: auto;
    font-size: 1.15vw;
}

.curtain{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #0003;
}

.color-container, .design-container, .option-container, .sizes-container,.inputs-container{
    width: 100%;
    border-bottom: 1px solid #E3E3E3;
    padding-bottom: 2%;
    margin-bottom: 2%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.color-container .title, .design-container .title, .option-container .title, .sizes-container .title, .inputs-container .title{
    font-weight: bold;
    font-size: 1.3vw;
}

.design-input-container{
    width: 100%;
    display: flex;
    padding: 1%;
    align-items: center;
    gap: 15px;
    margin: 3% 0 2%;
    padding: 0% 5%;
}

.design-input-container .file-uploader{
    display: none;
}

.design-input-container label{
    cursor: pointer;
}

.design-input-container .outer-label{
    background-color: #fff;
    box-shadow: 2px 2px 10px 3px rgba(0,0,0,.04);
    font-size: 1vw;
    font-style: normal;
    padding: 2% 10%;
    border-radius: 40px;
    position: relative;
    text-align: center;
    display: flex;
    justify-content: center;
    width: auto;
}

.design-input-container .inner-label{
    align-items: center;
    display: flex;
    justify-content: center;
    gap: 5px;
}

.clear-image{
    font-size: 1.5vw;
    color: gray;
    cursor: pointer;
}

.design-input-container .main-text{
    color: #A01ADB;
    white-space: nowrap;
    font-weight: 600;
    text-decoration: underline;
    display: flex;
    align-items: center;
    gap: 10px;
}

.design-input-container .main-text img{
    width: 12px;
}

.design-container .legend, .option-container .legend{
    display: flex;
    gap: 15px;
    width: 100%;
    align-items: center;
}

.design-container .legend .i-icon, .option-container .legend .i-icon{
    width: 20px;
    height: auto;
}

.design-container .legend span, .option-container .legend span{
    font-size: 0.8vw;
    color: gray;
    line-height: 1.2;
}

.arrow {
    border: solid black;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    height: 0px;
    transition: all 0.5s;
    cursor: pointer;
}

.arrow.up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
}

.arrow.down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}

.arrow.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.arrow.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.variant-container{
    width: 100%;
    padding: 0% 5%;
    margin: 3% 0 0%;
}

.colors-button-container{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
    flex-wrap: wrap;
}

.round-color{
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 100px;
    position: relative;
    cursor: pointer;
    box-shadow: 0 0 0px 0.5px #00000099;
}

.round-color.selected:after {
    content: "";
    display: block;
    position: absolute;
    background: transparent;
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    border-radius: 50%;
    top: 1px;
    left: 1px;
    border: 2px solid #fff;
}

.variants-button-container{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 15px;
    margin: 3% 0;
    padding: 0% 5%;
}

.variants-button-container button{
    font-size: 1vw;
    padding: 2% 5%;
    border: 1px solid lightgray;
}

.variants-button-container button.selected{
    background-color: #5cffc0;
}

.sizes-selection-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin: 3% 0;
    padding: 0% 5%;
}

.size-selection{
    display: flex;
    align-items: center;
    gap: 10px;
}

.size-selection p{
    font-size: 1.15vw;
    font-weight: bold;
    line-height: 1;
}


.size-selection input{
    background: unset;
    background-color: white;
    appearance: auto;
    height: unset !important;
    padding: 5px !important;
    border-radius: 4px !important;
    width: 50px;
    min-width: 50px;
    line-height: 1;
    font-size: 12px;
}

.product-total{
    font-size: 1.3vw;
    display: flex;
    width: 100%;
    justify-content: space-between;
    font-weight: bold;
    margin: 1% 0 3%;
}

.total-qty{
    font-size: 1vw;
    color: gray;
    line-height: 1.2;
    width: 100%;
    padding: 0% 5%;
}

.total-qty span{
    color: #502482;
}

.total-qty .red{
    color: red;
}

.mobile-sticky{
    display: flex;
    flex-direction: column;
}

.no-size{
    font-size: 1.15vw;
    display: flex;
}

.color-modal{
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #0000002f;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
}

.color-modal-container{
    width: 60%;
    height: auto;
    display: flex;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 0px 0px 1px #0000002f;
    flex-direction: column;
    align-items: center;
    padding: 3%;
}

.color-modal-container .title{
    font-weight: 700;
    font-size: 3vw;
    line-height: 1;
}

.color-modal-container .subtitle{
    color: #919191;
    font-size: 1.15vw;
    margin: 2% 0%;
    padding-bottom: 2%;
    border-bottom: 1px solid #919191;
    width: 100%;
    text-align: center;
}

.color-modal-container button{
    width: 100%;
}

.color-modal-container .red-alert{
    font-size: 1.15vw;
    color: red;
}

.color-modal-container .main-container{
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 5%;
}

.color-modal-container .current-pick{
    width: 33%;
}

.color-modal-container .current-pick .title{
    display: flex;
    font-size: 1.5vw;
    font-weight: bold;
    gap: 10px;
    padding: 5% 0%;
    align-items: center;
    justify-content: space-between;
}

.color-modal-container .current-pick img{
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
}

.color-modal-container .color-pick{
    border-left: 1px solid #919191;
    width: 60%;
    padding: 2%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.color-modal-container .color-pick .variant-container{
    margin: unset;
    padding: unset
}

.color-modal-container .color-pick .variant-container .title{
    font-size: 1.5vw;
    font-weight: bold;
    padding: 3% 0%;
}

.color-modal-container .color-pick .final-design{
    color: #919191;
    font-size: 0.9vw;
    font-style: italic;
    margin: 2% 0%;
    padding-bottom: 2%;
    border-bottom: 1px solid #919191;
    width: 100%;
}

.color-modal-container .color-pick .selected-colors{
    display: flex;
}

.color-modal-container .color-pick .selected-colors span{
    color: #919191;
    font-size: 1.5vw;
    font-weight: bold;
}

.color-modal-container .color-pick .selected-colors .qty{
    color: #0f0c38;
}

.floating-editor{
    position: absolute;
    left: 0%;
    width: auto;
    display: flex;
    gap: 20px;
    z-index: 1;
    top: 10%;
}

.floating-editor .arrow-container{
    border: 1px solid #ddddde;
    background-color: #e7ebfa;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100px;
    min-width: 40px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    cursor: pointer;
}

.floating-edit-options{
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex-basis: 100%;
    width: auto;
    flex-grow: 1;
    flex-shrink: 0;
}

.floating-container{
    border: 1px solid #ddddde;
    background-color: #e7ebfa;
    border-radius: 20px;
}

.fixed-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.8vw;
    gap: 15px;
    cursor: pointer;
    padding: 3% 10%;
    width: auto;
}

.fixed-container img{
    height: 15px;
}

.turnaround{
    font-size: 1vw;
    font-family: Karla, sans-serif;
    border-radius: 8px;
    background-color: #f5faff;
    color: #4239bc;
    padding: 0.5rem;
    width: 100%;
    display: block;
    font-weight: 400;
}

.input-selection-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin: 3% 0;
    padding: 0% 5%;
    flex-direction: column;
}

.input-selection{
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
}

.input-selection p{
    font-size: 1.15vw;
    font-weight: bold;
    line-height: 1;
    flex-shrink: 0;
}


.input-selection input{
    background: unset;
    background-color: white;
    appearance: auto;
    min-height: 1rem;
    padding: 5px !important;
    border-radius: 4px !important;
    width: 100%;
    min-width: 50px;
    flex-shrink: 1;
    line-height: 1;
    font-size: 12px;
}

.input-selection .color{
    width: 2rem;
}

.color-results{
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.color-results div{
    display: flex;
    gap: 5px;
    align-items: center;
}

@media screen and (max-width: 767px){
    .brandable-modal-page{
        overflow-y: scroll;
        flex-direction: column;
        min-height: calc(100% - 80px);
        justify-content: unset;
        top: 80px;
    }

    .images-container{
        width: 100%;
        height: unset;
    }

    .customization-container{
        border-top: 1px solid #E3E3E3;
        border-left: unset;
        width: 100%;
        height: unset;
        padding: 2% 5% 0%;
        overflow: visible;
    }

    .no-size{
        font-size: 3.5vw;
        align-items: flex-start;
    }

    .title-container.mobile{
        display: flex;
        flex-direction: column;
        align-items: unset;
    }

    .title-container.desktop{
        display: none;
    }

    .title-container .title{
        font-size: 6vw;
    }

    .title-container .information-toggle{
        font-size: 2.5vw;
    }

    .curtain{
        z-index: 1;
    }

    .title-container .information-toggle.toggle{
        z-index: 2;
    }

    .desc-outer-container{
        z-index: 2;
        left: -10%;
        width: 300%;
        right: unset;
        font-size: 3vw;
    }

    .exit{
        font-size: 3.5vw;
        position: sticky;
        background-color: white;
        top: 0;
        z-index: 1;
        border-bottom: 1px solid #E3E3E3;
        width: 100vw;
        margin-left: -5vw;
        padding: 0% 5%;
    }

    .color-container .title, .design-container .title, .option-container .title, .sizes-container .title,.inputs-container .title{
        font-size: 3.5vw;
    }

    .design-input-container .outer-label{
        font-size: 3vw;
        width: 100%;
        padding: 3% 10%;
    }

    .design-container .legend span, .option-container{
        gap: 5px;
    }
    .design-container .legend span, .option-container .legend span{
        font-size: 2.5vw;
    }

    .size-selection p,.input-selection p{
        font-size: 3.5vw;
    }

    .variants-button-container button{
        font-size: 3vw;
        padding: 2% 10%;
    }

    .total-qty{
        font-size: 3vw;
    }

    .product-total{
        font-size: 3.5vw;
    }

    .mobile-sticky{
        position: sticky;
        bottom: 0;
        background-color: white;
        padding: 5%;
        margin-left: -6%;
        width: 111%;
        box-shadow: 0 0 2px 0px #0000004d;
    }

    .size-selection{
        border: 1px solid gray;
        border-radius: 30px;
        padding-left: 2%;
        width: 45%;
    }

    .size-selection input{
        border: unset !important;
        border-left: 1px solid gray !important;
        border-radius: 0px 20px 20px 0 !important;
        width: 100%;
    }

    .clear-image{
        font-size: 5vw;
    }

    .color-modal{
        top: 80px;
        height: calc(100% - 80px);
        position: fixed;
    }
    .color-modal-container .main-container{
        flex-direction: column;
    }

    .color-modal-container{
        width: 90%;
    }

    .color-modal-container .title{
        font-size: 6vw;
    }

    .color-modal-container .subtitle{
        font-size: 3vw;
    }

    .color-modal-container .current-pick{
        width: 100%;
    }

    .color-modal-container .current-pick .title,.color-modal-container .color-pick .variant-container .title,.color-modal-container .color-pick .selected-colors span{
        font-size: 3.5vw;
    }
    .color-modal-container .color-pick{
        width: 100%;
        border-top: 1px solid #919191;
        border-left: unset;
    }

    .color-modal-container .color-pick .final-design{
        font-size: 2vw;
    }

    .floating-editor{
        top: 45%;
    }

    .floating-editor .arrow-container{
        min-height: 80px;
        min-width: 30px;
    }

    .fixed-container{
        font-size: 2.5vw;
    }

    .turnaround{
        font-size: 3vw;
    }
    
    .input-selection{
        flex-direction: column;
    }
}


</style>